import { render, staticRenderFns } from "./ReviewMessage.vue?vue&type=template&id=5c53b8dc&scoped=true&"
import script from "./ReviewMessage.vue?vue&type=script&lang=js&"
export * from "./ReviewMessage.vue?vue&type=script&lang=js&"
import style0 from "./ReviewMessage.vue?vue&type=style&index=0&id=5c53b8dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c53b8dc",
  null
  
)

export default component.exports